module.exports = __webpack_public_path__ + "static/img/dq10.79565bf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pic/dq10.png
// module id = 1vjQ
// module chunks = 0